import { render, staticRenderFns } from "./transaccion-detalle.vue?vue&type=template&id=2ecd3a2c&"
import script from "./transaccion-detalle.vue?vue&type=script&lang=ts&"
export * from "./transaccion-detalle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports